<span *ngIf="!answerType">{{ 'TQ_ANSWERS_HEADER.ANSWERS' | translate }}</span>
<span *ngIf="isMultipleChoice()">{{ 'TQ_ANSWERS_HEADER.MULTIPLE_CHOICE' | translate }}</span>
<span *ngIf="isMultipleSelect()">{{ 'TQ_ANSWERS_HEADER.MULTISELECT' | translate }}</span>
<span *ngIf="utils.isFreeForm(answerType, manipulativeType)">{{ 'TQ_ANSWERS_HEADER.FREE_FORM' | translate }}</span>
<span *ngIf="isManipulative()">{{ 'TQ_ANSWERS_HEADER.MANIPULATIVE' | translate }}</span>
<span *ngIf="showFullList && isArrangeInOrder()">{{ 'TQ_ANSWERS_HEADER.ARRANGE_IN_ORDER' | translate }}</span>
